import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navigation from "../../../components/Navigation/Navigation";
import FrontendFooter from "../../../components/Layout/FrontendFooter";
import ProductSlider from "../../../components/ProductSlider/ProductSlider";
import FeaturedProductsSlider from "../../../components/ProductSlider/FeaturedProductsSlider";
import "../../../components/ProductSlider/FeaturedProductsSlider.css";
import { API_ENDPOINTS } from "../../../config/api";
import "./Home.css";
import AppStoreImage from "../../../assets/images/app.jpg";
import AppIcon from "../../../assets/images/app-icon.png";
import GoogleIcon from "../../../assets/images/google-icon.png";
import { Container } from "@mui/material";
import AboutImage from "../../../assets/images/about.jpg";
import IphoneImage from "../../../assets/images/ipohone.jpg";

const Home = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sliderImages = [
    "https://www.bharatsteels.in/blog/wp-content/uploads/2021/10/steel.jpg",
    "https://www.bharatsteels.in/blog/wp-content/uploads/2021/10/steel.jpg",
    "https://www.bharatsteels.in/blog/wp-content/uploads/2021/10/steel.jpg",
    "https://www.bharatsteels.in/blog/wp-content/uploads/2021/10/steel.jpg",
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.PRODUCTS.BASE);
        // Check if response.data is an object with a data or products array, or if it's the array itself
        const productData =
          response.data.products || response.data.products || response.data;

        if (Array.isArray(productData)) {
          setProducts(productData);
        } else {
          console.error(
            "API did not return an array of products:",
            response.data
          );
          setError(new Error("Invalid data format from API"));
        }
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleEnquiryClick = () => {
    navigate("/about");
  };

  if (loading) {
    return (
      <div className="app-container">
        <Navigation />
        <main className="home-container">Loading products...</main>
        <FrontendFooter />
      </div>
    );
  }

  if (error) {
    return (
      <div className="app-container">
        <Navigation />
        <main className="home-container">
          Error loading products: {error.message}
        </main>
        <FrontendFooter />
      </div>
    );
  }

  return (
    <div className="app-container">
      <Navigation />
      <ProductSlider />

      <section className="home-about">
        <Container maxWidth="lg">
          <Grid
            className="home-about-container"
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid size={{ xs: 12, md: 5 }} order={{ xs: 1, md: 2 }}>
              <div className="home-about-image">
                <img
                  src={AboutImage}
                  alt="About Us"
                />
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} order={{ xs: 1, md: 2 }}>
              <div className="home-about-content">
                <h2 className="page-title">Who we are</h2>
                <p>
                Steelbuddy is a modern digital platform from the renowned Vizag Profiles Group, created to simplify and enhance the steel trading experience for customers, distributors, and manufacturers alike. The group leveraging over 25 years of excellence in steel handling, trading, and manufacturing, Steelbuddy blends cutting-edge technology with deep industry expertise and a trusted supplier network.

                </p>
                <p>
                Designed to bring convenience, speed, and reliability to steel supply process, Steelbuddy allows users to raise product enquiries seamlessly through its mobile app or website.
                </p>
                
                <div className="home-about-buttons">
                  <button
                    className="enquiry-button"
                    onClick={handleEnquiryClick}
                  >
                    Read More
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Featured Products Section */}
      <section className="products-section">
        <Container maxWidth="xl">
          <h2 className="page-title">Featured Products</h2>
          <FeaturedProductsSlider products={products} />

         
        </Container>
      </section>

      <section className="download-app">
        <Container maxWidth="lg">
          <Grid
            className="download-content"
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid size={{ xs: 12, md: 5 }} order={{ xs: 1, md: 2 }}>
              <div className="download-app-image">
                <img src={IphoneImage} alt="App Download Mockup" />
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} order={{ xs: 2, md: 1 }}>
              <div className="download-app-content">
                <h2>Download Our New App</h2>
                <h3>Your Steel, Your Way – Get the SteelBuddy App</h3>
                <p>
                Experience SteelBuddy on your smartphone—your trusted hub to explore, submit enquiries, and get real-time updates. Download now for exclusive offers and a simplified steel enquire experience at your fingertips.
                </p>
                <div className="download-app-buttons">
                  <a href="https://play.google.com/store/apps/details?id=com.f9tech.steelBudy&pcampaignid=web_share&pli=1" target="_blank" rel="noopener noreferrer" className="store-button">
                    <img src={GoogleIcon} alt="Google Play Store" />
                  </a>
                  <div className="store-buttons">
                    <a href="https://apps.apple.com/in/app/steel-buddy-pro/id6749255043" target="_blank" rel="noopener noreferrer" className="store-button">
                      <img src={AppIcon} alt="App Store" />
                    </a>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section className="steps-section">
        <div className="home-container">
          <h2 className="page-title text-center mb-30">
          Steps to Download the SteelBuddy App
          </h2>
          <div className="steps-container">
            <div className="step-item">
              <div className="step-icon">📱</div>
              <h3>Step 1: Open Your App Store</h3>
              <p>
              Go to the Google Play Store (Android) or Apple App Store (iOS) on your mobile device.
              </p>
            </div>
            <div className="step-item">
              <div className="step-icon">🔍</div>
              <h3>Step 2: Search “SteelBuddy”</h3>
              <p>
              Type SteelBuddy in the search bar and hit search.
              </p>
            </div>
            <div className="step-item">
              <div className="step-icon">⬇️</div>
              <h3>Step 3: Download & Install              </h3>
              <p>
              Tap Install (Android) or Get (iOS) to download the app to your device.
              </p>
            </div>
            <div className="step-item">
              <div className="step-icon">🚀</div>
              <h3>Step 4: Start Exploring Steel</h3>
              <p>
              Open the app, sign up or log in, and browse our complete range of steel products, submit an enquiry, and receive quick response.

              </p>
            </div>
          </div>
        </div>
      </section>

      <FrontendFooter />
    </div>
  );
};

export default Home;
